import React, { useEffect, useCallback } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";


import { useDispatch } from "react-redux";
import { getDetailEntete, getDetailLigneEntete } from "../../Redux/reclamationReduce";

const ImprimerAvoirReclamation = ({ t, idReclamation, type }) => {


  const dispatch = useDispatch();


  useEffect(() => {

  }, [idReclamation]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };


  function formatNumberTND(number) {
    if (isNaN(number)) return "";
    return number
      .toFixed(3)                 // 3 décimales
      .replace(".", ",")          // séparateur décimal
      .replace(/\B(?=(\d{3})+(?!\d))/g, "\u00A0"); // espace insécable tous les 3 chiffres
  }


  const generatePDF = async () => {
    const det = await dispatch(getDetailLigneEntete({ idReclamation }));
    const dataD = await det.payload;
    const data = Object.values(dataD).flatMap(group =>
      group.ligne.map(item => {
        return {
          codePCT: group.entete?.produits?.Code_PCT || "",
          codeInterne: group.entete?.produits?.Code_article || "",
          designation: group.entete?.produits?.Designation_1 || "",
          motif: group.entete?.motif_description || "",
          lot: group.entete?.lot || "",
          bl: item.numero_livraison || "",
          date_expiration: item.date_expiration || "",
          quantite: item.quantite_grossiste || 0,
          quantite_rectifier: item.quantite || 0,
          totalHT: item.prixuunitaire ? item.prixuunitaire * item.quantite : group.entete?.produits?.Prix * item.quantite
        };
      })
    );



    const reclamationRes = await dispatch(getDetailEntete({ idReclamation }));
    const reclamation = await reclamationRes.payload;

    const doc = new jsPDF();
    let currentY = 20;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");

    // Récupère la largeur de la page
    const pageWidth = doc.internal.pageSize.getWidth();

    // Positionne le texte au centre
    doc.text(`Demande d'établissement d'un Avoir Client`, pageWidth / 2, currentY, { align: 'center' });
    currentY += 20;

    doc.setFont("helvetica", "normal");

    // Bloc d'information générale
    doc.setFontSize(10);
    doc.text(`Référence Retour : ${reclamation.numero || ""}`, 14, currentY); currentY += 6;
    doc.text(`Date de réception du Retour : ${formatDate(reclamation.createdAt) || ""}`, 14, currentY); currentY += 6;
    doc.text(`Date de traitement du retour : ${formatDate(reclamation.date_traitement_afc) || ""}`, 14, currentY); currentY += 6;
    doc.text(`Nom de l'émetteur (Commercial) : ${reclamation.afcs?.nom_prenom || ""}`, 14, currentY); currentY += 6;
    doc.text(`Code Client : ${reclamation.grossistes?.Code_client || ""}`, 14, currentY); currentY += 6;
    doc.text(`Désignation client : ${reclamation.grossistes?.Raison_sociale || ""}`, 14, currentY); currentY += 6;
    doc.text(`Avoir N° : _________________________`, 14, currentY); currentY += 10;

    // Tableau produits
    doc.autoTable({
      startY: currentY,
      head: [[
        "Code Interne", "Désignation", "Motif", "N° Lot", "N° BL",
        "Date Péremption", "Quantité demandée", "Quantité Approuvée", "Total HT"
      ]],
      body: data.map(item => [
        item.codeInterne,
        item.designation,
        item.motif,
        item.lot,
        item.bl,
        item.date_expiration,
        item.quantite,
        item.quantite_rectifier,
        formatNumberTND(item.totalHT)
      ]),
      styles: { fontSize: 8 },
      headStyles: { fillColor: [221, 221, 221], textColor: 0 }
    });

    currentY = doc.lastAutoTable.finalY + 10;

    // Valeur totale
    const total = data.reduce((acc, item) => acc + Number(item.totalHT), 0);
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text(`Valeur Totale HT : ${formatNumberTND(total)}`, 150, currentY, { align: 'right' });
    currentY += 20;

    // Signatures (sous forme de tableau)
    doc.setFontSize(10);
    doc.text("Signatures :", 14, currentY);
    currentY += 10;

    doc.autoTable({
      startY: currentY,
      head: [[
        "Émetteur",
        "Responsable Administration des ventes",
        "Responsable Financier"
      ]],
      body: [[
        "", "", "" // Laisser vide pour les signatures
      ]],
      theme: 'grid',
      styles: {
        minCellHeight: 20, // hauteur pour l'espace de signature
        halign: 'center',
        fontSize: 10
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: 0,
        fontStyle: 'bold',
        lineWidth: 0.1
      },
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.1
    });

    doc.save(`demande-${reclamation.numero}.pdf`);
  };





  return (
    <button onClick={generatePDF} className={type == 2 ? "btn btn-pdf w-100" : "btn btn-pdf"}>
      {type == 2 ? t("Télécharger Recap") : <i class="fa-solid fa-file-pdf"></i>}
    </button>
  );
};

export default ImprimerAvoirReclamation;
